/**
 * Lazy-loaded phone validation using library function
 * Only imports the package when validation is actually performed
 */

let isPhoneValidatorLoaded = false;
let isPossiblePhoneNumber: ((phone: string) => boolean) | null = null;

/**
 * Lazy load the phone validation function
 */
const loadPhoneValidator = async (): Promise<(phone: string) => boolean> => {
  if (isPhoneValidatorLoaded && isPossiblePhoneNumber) {
    return isPossiblePhoneNumber;
  }

  const module = await import("react-phone-number-input");
  isPossiblePhoneNumber = module.isPossiblePhoneNumber;
  isPhoneValidatorLoaded = true;
  return isPossiblePhoneNumber;
};

/**
 * Validate phone number using the library method (lazy-loaded)
 * Returns false if phone is empty or invalid
 */
export const isValidPhoneNumber = async (phone?: string): Promise<boolean> => {
  if (!phone || typeof phone !== "string" || phone.trim() === "") {
    return false;
  }

  const validator = await loadPhoneValidator();
  return validator(phone);
};
